﻿import {Word} from './word';

export class Intercalaire {
    id: string;
    name: string;
    color: string;
    words: Word[];

    constructor(json: any) {
        this.id = json.id;
        this.name = json.name;
        this.color = json.color;
        this.words = json.words;
    }
}
